import { toFloatFormatterUtil } from 'models/formatters/utils'
import { formatInstance } from 'models/formatters'
import { CATEGORY_BEFORE_VALIDATE_HOOK } from 'models/daos/category/hooks/before-validate'

const FORMATTER_MAP = {
  weight: toFloatFormatterUtil,
  height: toFloatFormatterUtil,
  ...CATEGORY_BEFORE_VALIDATE_HOOK
}

function formatInstanceBeforeValidate (params) {
  return formatInstance({
    ...params,
    formatterMap: FORMATTER_MAP
  })
}

export {
  formatInstanceBeforeValidate
}
